import {MultiselectConfig} from '../../components/multiselect';
import {FilterCriterionMultiselect} from './filter-criterion-input';
import {QueryLangFilterCriterion} from './query-lang-filter-criterion';

export class QueryLangFilterCriterionMultiselect<ITEM extends Record<string, any> = any>
    extends QueryLangFilterCriterion<ITEM>
    implements FilterCriterionMultiselect {

    public name: string;
    public multiselectConfig: MultiselectConfig;
}
